import { styled } from 'linaria/react';
import { css } from 'linaria';

export const FilterListStyles = css`
	grid-auto-rows: max-content;
	grid-row-gap: 16px;
	height: max-content;

	& > li:last-child {
		margin-bottom: 15px;
	}
`;

export const HiddenList = styled.div<{ isOpen: boolean }>`
	max-height: ${({ isOpen }) => (isOpen ? '2000px' : '0')};
	overflow: hidden;
	transition: max-height 0.5s ease-in-out;
`;

export const ShowMoreItemsBtnStyles = css`
	padding: 0 !important;
	margin: 0;

	& > span > div {
		width: 15px !important;
		height: 15px !important;
	}

	@media (hover: hover) {
		background-color: #fff !important;
	}
`;
